import { DefaultCompetitorModal } from "../CompetitorsCollapse/layout/DefaultCompetitorModal/DefaultCompetitorModal"
import { useAddModelNumber } from "hooks/api/modelNumbers/modelNumbers.hook"
import { useApiErrorFormatter } from "hooks/apiErrorFormatter.hook"
import { useMessage } from "hooks/message.hook"
import { useQueryClient } from "@tanstack/react-query"

type Props = { isModalOpen: boolean; setModalClose: () => void }

export const AddModelNumberModal = ({ isModalOpen, setModalClose }: Props) => {
	const { mutate: addModelNumberMutation } = useAddModelNumber()
	const { success } = useMessage()
	const { formatError } = useApiErrorFormatter()
	const queryClient = useQueryClient()

	const onSaveHandle = (name: string) => {
		const formData = new FormData()
		formData.append("model_number", name)

		addModelNumberMutation(
			{ formData },
			{
				onSuccess: () => {
					success("Model number added successfully")
					setModalClose()
					queryClient.invalidateQueries({ queryKey: ["competitorsModelNumbers"] })
				},
				onError: (error) => {
					formatError(error)
				},
			},
		)
	}

	return (
		<DefaultCompetitorModal
			isModalOpen={isModalOpen}
			setModalClose={setModalClose}
			title="Add new Stevens model number"
			inputLabel="Model number"
			validationMessage="Please enter model number"
			cancelButtonText="Cancel"
			saveButtonText="Add"
			onSave={onSaveHandle}
		/>
	)
}
